export default __webpack_public_path__ + "static/media/mentors-1.2c78daf3.jpg";